import { cn } from "@/utils/css";
import { MapLegendElement } from "@/components/maps/MapLegendElement";

export const MapLegend = ({ side = "right", className }) => {
    return (
        <div
            className={cn(
                "absolute right-0 bottom-10 flex flex-col",
                {
                    "left-0 right-auto bottom-0": side === "left",
                },
                className,
            )}
        >
            <MapLegendElement text="prime" side={side} />
            <MapLegendElement text="stable" side={side} />
            <MapLegendElement text="average" side={side} />
            <MapLegendElement text="weak" side={side} />
        </div>
    );
};
